import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";

const ROLES = ["Admin", "Commercial", "Viewer"];

export const ProvisionUserDialog = ({ open, onOpenChange, form, onFormChange, result, onSubmit, submitting }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-3xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-display flex items-center gap-2">
          <UserPlus className="w-5 h-5 text-emerald-400" />
          {result ? "Compte créé ✓" : "Créer un accès commercial"}
        </DialogTitle>
      </DialogHeader>
      {!result ? (
        <div className="space-y-3 mt-2">
          <p className="text-xs text-zinc-500">Le commercial recevra ses identifiants par email. Il pourra se connecter immédiatement sur Prosperr.</p>
          <div>
            <Label className="text-xs font-semibold">Nom complet</Label>
            <Input value={form.name} onChange={(e) => onFormChange({ ...form, name: e.target.value })} className="rounded-2xl mt-1 h-11" placeholder="Jean Dupont" data-testid="provision-name" />
          </div>
          <div>
            <Label className="text-xs font-semibold">Email professionnel</Label>
            <Input type="email" value={form.email} onChange={(e) => onFormChange({ ...form, email: e.target.value })} className="rounded-2xl mt-1 h-11" placeholder="jean@entreprise.fr" data-testid="provision-email" />
          </div>
          <div>
            <Label className="text-xs font-semibold">Rôle</Label>
            <Select value={form.role} onValueChange={(v) => onFormChange({ ...form, role: v })}>
              <SelectTrigger className="rounded-2xl mt-1 h-11" data-testid="provision-role"><SelectValue /></SelectTrigger>
              <SelectContent>
                {ROLES.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <Button onClick={onSubmit} disabled={submitting} className="w-full rounded-full bg-emerald-500/100 hover:bg-emerald-500 h-12 font-semibold" data-testid="provision-confirm">
            {submitting ? "Création…" : "Créer le compte"}
          </Button>
        </div>
      ) : (
        <div className="space-y-3 mt-2">
          <div className="bg-emerald-500/10 border border-emerald-500/40 rounded-2xl p-4">
            <div className="text-xs text-emerald-300 font-semibold">Compte actif immédiatement</div>
            <div className="mt-2 space-y-2">
              <div>
                <div className="text-[10px] text-zinc-500 uppercase tracking-wider">Email</div>
                <div className="font-semibold text-sm text-[var(--text)]">{result.user.email}</div>
              </div>
              <div>
                <div className="text-[10px] text-zinc-500 uppercase tracking-wider">Mot de passe temporaire</div>
                <div className="flex items-center gap-2">
                  <code className="font-mono text-sm bg-[var(--surface)] rounded-lg px-2 py-1 border border-[var(--border)] flex-1">{result.temp_password}</code>
                  <Button size="sm" variant="outline" onClick={() => { navigator.clipboard.writeText(result.temp_password); toast.success("Copié"); }} className="rounded-full h-8 text-xs" data-testid="copy-temp-password">
                    Copier
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {!result.email_sent && (
            <div className="text-[11px] text-amber-300 bg-amber-500/10 border border-amber-200 rounded-xl p-2.5">
              ⚠️ L'email n'a pas pu être envoyé (Resend non configuré). Transmettez ces identifiants manuellement.
            </div>
          )}
          <Button onClick={() => onOpenChange(false)} className="w-full rounded-full bg-slate-900 text-white h-11 font-semibold" data-testid="provision-done">
            Terminé
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
